import { zodSchemes } from '@approvalmax/utils';
import { CountryIsoCode } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { eighteenYearsEarlier, socialSecurityNumberRegexp } from './PersonVerificationDetails.constants';
import { messages } from './PersonVerificationDetails.messages';

const addressSchema = z.object({
    city: zodSchemes.required.textField.string(),
    street: zodSchemes.required.textField.string(),
    country: zodSchemes.required.select.enum(CountryIsoCode),
    state: z.string().optional(),
    postalCode: zodSchemes.required.textField.string(),
    buildingNumber: zodSchemes.required.textField.string(),
    buildingName: zodSchemes.required.textField.string(),
    apartmentNumber: z.string().optional(),
});

export const basePersonSchema = z.object({
    dob: z.date({ required_error: messages.requiredField }).max(eighteenYearsEarlier(), {
        message: messages.personMustBeMoreThan18YearsOld,
    }),
    phoneNumber: zodSchemes.required.textField.string(),
    address: addressSchema,
});

const usPersonSchema = basePersonSchema.extend({
    isUs: z.literal(true),
    idNumber: zodSchemes.required.textField.string().refine((value) => socialSecurityNumberRegexp.test(value), {
        message: messages.idNumberInvalid,
    }),
});

const nonUsPersonSchema = basePersonSchema.extend({
    isUs: z.literal(false),
});

const personSchema = z.discriminatedUnion('isUs', [usPersonSchema.passthrough(), nonUsPersonSchema.passthrough()]);

export const schema = z.object({ person: personSchema });
